import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { DashboardEntryGuard } from 'app/core/auth/guards/dashboard-entry.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { RefreshTokenComponent } from './modules/dashboard/refresh-token/refresh-token.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path - landing page is resolved per role by DashboardEntryGuard
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'callback', loadChildren: () => import('app/modules/auth/callback/callback.routes') },
            { path: 'privacy-policy', loadChildren: () => import('app/modules/legal/privacy-policy/privacy-policy.routes') },
            { path: 'terms-and-conditions', loadChildren: () => import('app/modules/legal/terms-and-conditions/terms-and-conditions.routes') },
        ]
    },

    // Dashboard routes (auth required; the profile itself is edited from Settings)
    {
        path: 'dashboard',
        canActivate: [AuthGuard, DashboardEntryGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'dense'
        },
        children: [
            // Default redirect handled by DashboardEntryGuard based on user roles
            { path: '', pathMatch: 'full', redirectTo: 'requester/request' }, // Fallback

            // Apps
            { path: 'profile', loadChildren: () => import('app/modules/dashboard/profile/profile.routes') },
            { path: 'requester/request', loadChildren: () => import('app/modules/dashboard/dipita/requester/request/request.routes') },
            { path: 'expert/contributions', loadChildren: () => import('app/modules/dashboard/dipita/expert/contributions/contributions.routes') },
            { path: 'expert/pending-requests', loadChildren: () => import('app/modules/dashboard/dipita/expert/pending-requests/pending-requests.routes') },
            { path: 'requester/patient', loadChildren: () => import('app/modules/dashboard/dipita/requester/patient/patient.routes') },
        ]
    },
    {
        path: 'refresh-token',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: RefreshTokenComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'empty'
        }
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
        ]
    },
];